import Vue from 'vue'
import VueRouter from 'vue-router'
import agreeMent from '@/components/agreeMent'
import openCard from '@/components/openCard'
import Moment from 'moment'
import WotDesign from 'wot-design'
import 'wot-design/lib/theme-default/index.css'

Vue.use(WotDesign)


import App from './App.vue'

import axios from 'axios'
import jsonp from 'jsonp'

import qs from 'qs';

// import Vconsole from 'vconsole';
// const vConsole = new Vconsole()
// Vue.use(vConsole)

axios.defaults.withCredentials = true
axios.defaults.headers['Content-Type'] = "application/json"

Vue.prototype.$axios = axios;
Vue.prototype.$jsonp = jsonp;
Vue.prototype.$qs = qs;

Vue.config.productionTip = false

Vue.use(VueRouter)

const router = new VueRouter({
    //base: '/history',
    //mode: 'history',
    routes: [
        { path: '/agreeMentCard', name: 'agreeMentCard', component: agreeMent },
        { path: '/', name: 'openCard', component: openCard },
    ]
})

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')